import * as React from "react";
import MuiCollapse, { CollapseProps } from "@material-ui/core/Collapse";

class Collapse extends React.PureComponent<CollapseProps> {
    render() {
        const { ...props } = this.props;
        return <MuiCollapse {...props}>
            {this.props.children}
        </MuiCollapse>;
    }
}

export default Collapse;